<template>
  <v-sheet
    height="100%"
    style="position: relative; margin-top:0px; border-radius:0; "
  >
    <Header title="Audio Studio" :title-size="32" :show-back="false" />
    <div class="d-flex align-center justify-space-around menu">
        <v-col class="convocatorias colstyle pa-0 background" @click="$router.push({name: 'citations'})" cols="4">
            <v-row class="pstyle">
                <p  class="text--text">Convocatorias</p>
            </v-row>
            <v-divider/>
            <v-row class="rowstyle">         
                <v-avatar color="admiraGreen" size="130">
                    <v-icon style="font-size:60px;" dark>mdi-microphone-outline</v-icon>
                </v-avatar>
            </v-row>
            <v-row style="justify-content: center;">
                <p style="font-size:16px"  class="text--text">Modo autónomo</p>
            </v-row>
        </v-col>  
        <v-col cols="4" class="convocatorias colstyle pa-0 background" @click="$router.push({name: 'sessions'})">
            <v-row class="pstyle">
                <p  class="text--text">Sesión de grabación</p>
            </v-row>    
            <v-divider/>
            <v-row class="rowstyle">
                <v-avatar color="admiraGreen" size="130">
                    <v-icon style="font-size:60px;" dark>mdi-record-circle-outline</v-icon>
                </v-avatar>
            </v-row>
            <v-row style="justify-content: center;">
                <p style="font-size:16px"  class="text--text">Grabaciones realizadas</p>
            </v-row>
        </v-col>    
    </div>
    <ConfigDialog :dialog="dialog" :close="() => dialog = false" :reconnectSocket="reconnectSocket" />
  </v-sheet>
</template>

<script>
import { mapState } from "vuex";
import { defineAsyncComponent } from "vue";


export default {
  name: "home",
  components: {
    Header: defineAsyncComponent(() => import("@/components/Header")),
    ConfigDialog: defineAsyncComponent(() => import("../dialogs/ConfigDialog.vue"))
  },
  data: () => ({
      dialog: false,
  }),
  computed: {
    ...mapState(["creatives","allowedCitations","studio"])
  },
  methods: {
    reconnectSocket() {
      if (this.$globalData.socket.connected) {
        this.$globalData.socket.once('disconnect', () => {
          this.$globalData.socket.connect();
        });
        this.$globalData.socket.disconnect();
      } else {
        this.$globalData.socket.connect();
      }
    }
  },
  created() {
    this.$store.commit("setAuxDateCitations", this.date)
    if(process.env.VUE_APP_MODE == "web") {
      this.$router.push({name: 'login'})
    }
  },
  }

</script>
<style scoped>
.menu{
    height: calc(100% - 100px);
}
.pstyle{
    color:#777777;
    font-size:24px;
    font-weight: 300;
    margin: 15px 0 0 0;
    justify-content: center;
}
.colstyle{
    height: 340px;
    background-color:white;
    border-radius:25px;
    box-shadow: 0px 3px 6px #00000029;
}
.rowstyle{
    margin:45px 0;
    justify-content: center;
}
.convocatorias:hover {
 cursor: pointer;
};
</style>